module.exports = __webpack_public_path__ + "img/icon-144x144.3bca970c.png";